import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../context/authContext';
import useHttp from './useHttp';

const useRegiondoValueVoucherImport = () => {
  const auth = useAuth();
  const { isLoading, error, sendRequest } = useHttp();

  const previewImport = useCallback(
    async payload => {
      try {
        return await sendRequest({
          url: '/api/v1/regiondoValueVoucherImport/preview',
          method: 'POST',
          headers: auth.getAuthHeaders(),
          body: payload,
        });
      } catch (err) {
        toast.error('Fehler bei der Pruefung der Regiondo-Gutscheine');
        throw err;
      }
    },
    [auth, sendRequest]
  );

  const executeImport = useCallback(
    async payload => {
      try {
        return await sendRequest({
          url: '/api/v1/regiondoValueVoucherImport/import',
          method: 'POST',
          headers: auth.getAuthHeaders(),
          body: payload,
        });
      } catch (err) {
        toast.error('Fehler beim Importieren der Regiondo-Gutscheine');
        throw err;
      }
    },
    [auth, sendRequest]
  );

  return { isLoading, error, previewImport, executeImport };
};

export default useRegiondoValueVoucherImport;
